import { mainSiteUrl } from "@/mocks/categories";

export interface ArticleData {
  id: string;
  slug: string;
  title: string;
  summary: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
  isExternal?: boolean;
  externalUrl?: string;
}

export const homepageArticles: ArticleData[] = [
  {
    id: "article-1",
    slug: "/artykul/kakobuy-spreadsheet-poradnik",
    title: "Kakobuy Spreadsheet – Kompletny Poradnik dla Kupujących z Polski (2026)",
    summary: "Dowiedz się, czym jest Kakobuy Spreadsheet, jak z niego korzystać, gdzie znaleźć najlepsze produkty i jak bezpiecznie robić zakupy przez chińskich agentów. Praktyczny przewodnik krok po kroku.",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20colorful%20spreadsheet%20data%2C%20surrounded%20by%20fashion%20sneakers%20and%20a%20coffee%20cup%2C%20soft%20morning%20sunlight%20streaming%20through%20large%20window%2C%20cream%20and%20warm%20beige%20tones%2C%20Scandinavian%20interior%20aesthetic%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=hp-article-01-v2&orientation=landscape",
    date: "21 lipca 2026",
    readTime: "8 min",
    tags: ["Kakobuy Spreadsheet", "poradnik", "zakupy"]
  },
  {
    id: "article-2",
    slug: "/artykul/kakobuy-buty-poradnik",
    title: "Kakobuy Buty – Jak Znaleźć Najlepsze Sneakersy w Spreadsheet?",
    summary: "Odkryj najlepsze sneakersy dostępne przez Kakobuy Spreadsheet. Porównanie modeli Nike, Jordan, Adidas i New Balance. Sprawdzone linki, ceny i opinie społeczności.",
    imageUrl: "https://readdy.ai/api/search-image?query=Collection%20of%20trendy%20sneakers%20in%20various%20colors%20arranged%20artistically%20on%20a%20light%20wooden%20floor%2C%20natural%20side%20lighting%20from%20window%2C%20minimalist%20room%20with%20white%20walls%20and%20a%20small%20plant%2C%20warm%20neutral%20tones%2C%20product%20photography%20style%20with%20clean%20composition&width=800&height=500&seq=hp-article-02-v2&orientation=landscape",
    date: "20 lipca 2026",
    readTime: "7 min",
    tags: ["Kakobuy buty", "sneakersy", "Nike", "Jordan"]
  },
  {
    id: "article-3",
    slug: "/artykul/kakobuy-bezpieczenstwo",
    title: "Czy Kakobuy Jest Bezpieczny? Kompletny Poradnik Bezpieczeństwa 2026",
    summary: "Wszystko co musisz wiedzieć o bezpieczeństwie na Kakobuy. Jak unikać oszustw, sprawdzać sprzedawców, korzystać z ochrony kupującego i bezpiecznie płacić.",
    imageUrl: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20modern%20smartphone%20displaying%20a%20secure%20shopping%20app%20interface%20with%20a%20shield%20icon%2C%20placed%20on%20a%20clean%20white%20desk%20next%20to%20a%20small%20green%20plant%2C%20soft%20daylight%20from%20window%2C%20calm%20and%20trustworthy%20atmosphere%2C%20minimalist%20aesthetic&width=800&height=500&seq=hp-article-03-v2&orientation=landscape",
    date: "19 lipca 2026",
    readTime: "6 min",
    tags: ["bezpieczeństwo", "Kakobuy", "ochrona kupującego"]
  },
  {
    id: "article-4",
    slug: "/artykul/kakobuy-wysylka-polska",
    title: "Kakobuy Wysyłka do Polski – Koszty, Czas i Najlepsze Opcje Dostawy",
    summary: "Kompletny przewodnik po wysyłce Kakobuy do Polski. Porównanie metod dostawy, orientacyjne ceny, czas oczekiwania oraz porady jak zaoszczędzić na transporcie.",
    imageUrl: "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20neatly%20stacked%20on%20a%20light%20wooden%20table%20near%20a%20large%20window%2C%20one%20box%20open%20revealing%20tissue%20paper%20and%20a%20sneaker%20peeking%20out%2C%20soft%20morning%20light%2C%20cream%20walls%2C%20warm%20minimalist%20interior%2C%20e-commerce%20lifestyle%20photography&width=800&height=500&seq=hp-article-04-v2&orientation=landscape",
    date: "18 lipca 2026",
    readTime: "5 min",
    tags: ["wysyłka Polska", "Kakobuy", "dostawa", "koszty"]
  },
  {
    id: "article-5",
    slug: "/artykul/kakobuy-dla-poczatkujacych",
    title: "Kakobuy dla Początkujących – Pierwsze Zakupy Krok po Kroku",
    summary: "Nigdy nie korzystałeś z Kakobuy? Ten poradnik przeprowadzi Cię przez cały proces – od rejestracji, przez wyszukiwanie produktów, aż po finalizację pierwszego zamówienia.",
    imageUrl: "https://readdy.ai/api/search-image?query=Young%20person%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20a%20notebook%20and%20smartphone%20nearby%2C%20on%20a%20bright%20minimalist%20desk%2C%20warm%20natural%20light%20from%20side%20window%2C%20cream%20and%20beige%20color%20palette%2C%20casual%20productivity%20scene%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=hp-article-05-v2&orientation=landscape",
    date: "17 lipca 2026",
    readTime: "10 min",
    tags: ["początkujący", "Kakobuy", "pierwsze zakupy"]
  },
  {
    id: "article-6",
    slug: "",
    title: "Kakobuy vs Pandabuy – Który Agent Zakupowy Jest Lepszy?",
    summary: "Szczegółowe porównanie Kakobuy i Pandabuy. Ceny, funkcje, jakość obsługi, dostępne marki i opinie użytkowników. Sprawdź, która platforma jest lepsza dla Ciebie.",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20concept%20with%20two%20smartphones%20side%20by%20side%20on%20a%20marble%20surface%2C%20each%20displaying%20different%20shopping%20app%20interfaces%2C%20soft%20studio%20lighting%2C%20minimalist%20cream%20background%2C%20clean%20product%20comparison%20photography%2C%20elegant%20composition&width=800&height=500&seq=hp-article-06-v2&orientation=landscape",
    date: "16 lipca 2026",
    readTime: "8 min",
    tags: ["porównanie", "Kakobuy", "Pandabuy"],
    isExternal: true,
    externalUrl: "https://kaspreadsheet.com"
  },
  {
    id: "article-7",
    slug: "",
    title: "Kakobuy QC – Jak Sprawdzać Produkty Przed Wysyłką?",
    summary: "Dowiedz się jak działa system Quality Check na Kakobuy. Jak zamówić zdjęcia QC, na co zwracać uwagę i kiedy warto poprosić o zwrot lub wymianę produktu.",
    imageUrl: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20smartphone%20screen%20showing%20product%20detail%20photos%2C%20on%20a%20clean%20white%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20office%20setup%20with%20a%20notepad%20nearby%2C%20cream%20and%20warm%20white%20tones%2C%20professional%20inspection%20theme%20photography&width=800&height=500&seq=hp-article-07-v2&orientation=landscape",
    date: "15 lipca 2026",
    readTime: "6 min",
    tags: ["QC", "Kakobuy", "kontrola jakości"],
    isExternal: true,
    externalUrl: "https://kaspreadsheet.com"
  },
  {
    id: "article-8",
    slug: "",
    title: "Najlepsze Kakobuy Znajdźki – Top 50 Produktów Tego Miesiąca",
    summary: "Aktualna lista najlepszych produktów znalezionych przez społeczność Kakobuy. Sneakersy, ubrania, akcesoria i perełki, które warto kupić w tym miesiącu.",
    imageUrl: "https://readdy.ai/api/search-image?query=Collage%20of%20various%20fashion%20items%20including%20sneakers%2C%20hoodies%2C%20caps%20and%20accessories%20arranged%20flat%20lay%20style%20on%20a%20light%20linen%20fabric%20background%2C%20soft%20diffused%20lighting%2C%20warm%20cream%20and%20earthy%20tones%2C%20lifestyle%20product%20photography%2C%20clean%20editorial%20aesthetic&width=800&height=500&seq=hp-article-08-v2&orientation=landscape",
    date: "14 lipca 2026",
    readTime: "12 min",
    tags: ["znajdźki", "Kakobuy", "top produkty"],
    isExternal: true,
    externalUrl: "https://kaspreadsheet.com"
  },
  {
    id: "article-9",
    slug: "",
    title: "Kakobuy Kod Rabatowy – Jak Zaoszczędzić na Zakupach?",
    summary: "Gdzie znaleźć działające kody rabatowe Kakobuy? Sprawdzone sposoby na oszczędzanie, promocje sezonowe i programy lojalnościowe dla stałych klientów.",
    imageUrl: "https://readdy.ai/api/search-image?query=Golden%20discount%20tag%20icon%20on%20a%20smartphone%20screen%20resting%20on%20a%20light%20wooden%20surface%2C%20surrounded%20by%20a%20small%20wallet%20and%20shopping%20bag%2C%20soft%20warm%20sunlight%2C%20minimalist%20cream%20background%2C%20savings%20and%20smart%20shopping%20concept%2C%20clean%20product%20photography&width=800&height=500&seq=hp-article-09-v2&orientation=landscape",
    date: "13 lipca 2026",
    readTime: "4 min",
    tags: ["kod rabatowy", "Kakobuy", "oszczędzanie"],
    isExternal: true,
    externalUrl: "https://kaspreadsheet.com"
  }
];